import { Link } from 'gatsby';
import styled, { css } from 'styled-components';

import { Color } from '../../../../constants/Colors';
import { MediaQuery } from '../../../../constants/Styles';
import { Typography } from '../../../../constants/Typographies';

export const ThemeCard = css`
  display: flex;
  flex-direction: column;
  border-radius: 30px;
  padding: 30px;
  margin: 10px 15px 0 15px;
  background: ${Color.ZIRCON};
  transition: transform 0.3s ease 0s;

  &:hover {
    transform: translateY(-10px);
  }

  ${MediaQuery.L_AND_DOWN} {
    margin: 20px;
    padding: 25px;
  }

  a {
    color: ${Color.BLUE_RIBBON};
  }

  svg {
    color: ${Color.BLUE_RIBBON};
  }
`;

export const CardCTA = styled.a`
  ${ThemeCard};
`;

export const CardCTAInternal = styled(Link)`
  ${ThemeCard};
`;

export const PictureWrapper = styled.div`
  border-radius: 15px;
  background: ${Color.WHITE};
  overflow: hidden;

  img {
    max-width: 320px;

    ${MediaQuery.S_AND_DOWN} {
      max-width: 220px;
    }

    ${MediaQuery.M_TO_L} {
      max-width: 460px;
    }
  }
`;

export const CardTitle = styled.h3`
  ${Typography.XXL_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin: 15px 0 25px 0;
`;

export const CardDescription = styled.p`
  ${Typography.M};
  color: ${Color.DOLPHIN};
  margin-bottom: 25px;
  max-width: 315px;
`;

export const CardLabel = styled.span`
  ${Typography.S_BOLDER};
  display: flex;
  flex-direction: row;
  color: ${Color.BLUE_RIBBON};
  text-decoration: none;
  align-items: center;
  box-sizing: border-box;
  font-weight: 900;

  svg {
    padding: 0 10px;
  }
`;
